import { staticGroupSchema } from "@redotech/redo-model/customers/customer-group-definition";
import * as z from "zod";

export const createStaticSegment = {
  name: "createStaticSegment" as const,
  input: z.object({ name: z.string() }),
  output: staticGroupSchema,
};
